import userActionType from "./userActionTypes";

const loginPending = () => ({
  type: userActionType.LOGIN_PENDING,
  isLoginPending: true,
});

const loginSuccess = (user) => ({
  type: userActionType.LOGIN_SUCCESS,
  isLoginPending: false,
  user,
});

const loginError = (message) => ({
  type: userActionType.LOGIN_ERROR,
  isLoginPending: false,
  message,
});

const logout = () => ({
  type: userActionType.LOGOUT,
  isLoginPending: false,
  user: null,
});

const changeLanguage = (lang) => ({
  type: userActionType.CHANGE_LANGUAGE,
  lang: lang,
});

export default {
  loginPending,
  loginSuccess,
  loginError,
  logout,
  changeLanguage,
};
